import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  resetHabit({ commit }, data) {
    commit(types.RESET_HABIT, data)
  },
  resetNutrition({ commit }, data) {
    commit(types.RESET_NUTRITION, data)
  },
  setHabitData({ commit }, data) {
    commit(types.SET_HABIT_DATA, data)
  },
  async getNutritionProfile({ commit }, data) {
    const r = await http.get(`v2/nutrition/liveprofilenutrition`, {
      params: data,
    })
    commit(types.SET_NUTRITION, r.data.data)
    return r.data.data
  },
  async getMealPlans({ commit }, id) {
    const r = await http.get(`v2/nutrition/mealplans?user_id=${id}`)
    commit(types.SET_MEALPLANS, r.data.data)
    return r.data.data
  },
  async getHabitIcons({ commit }) {
    const r = await http.get('v2/nutrition/habiticons')
    commit(types.SET_HABIT_ICONS, r.data)
    return r.data.data
  },
  async getHabits({ commit }, data) {
    const r = await http.get('v2/nutrition/habits', {
      params: data,
    })
    commit(types.SET_NUTRITION_HABITS, r.data.data)
    return r.data.data
  },
  async editHabit({ commit }, id) {
    // const r = await http.get(`v2/nutrition/habit?id=${id}`)
    commit(types.SET_NUTRITION_HABIT, id)
    // return r.data.data
  },
  async saveHabit({ commit }, data) {
    const r = await http.post(`v2/nutrition/habit`, data)
    return r.data.data
  },
  async removeHabit({ commit }, id) {
    const r = await http.delete(`v2/nutrition/habit/${id}`)
    return r.data.data
  },
}
